import React from 'react';
import { Checkbox } from 'semantic-ui-react';

type AllowEstateUserPlEditToggleProps = {
  checked?: boolean;
  onChange: (checked: boolean) => void;
};

export const AllowEstateUserPlEditToggle = ({
  checked,
  onChange
}: AllowEstateUserPlEditToggleProps) => {
  return (
    <div
      style={{
        display: 'flex',
        alignItems: 'flex-start',
        gap: 12,
        margin: '8px 0 16px'
      }}
    >
      <Checkbox
        toggle
        checked={Boolean(checked)}
        onChange={(_, data) => onChange(Boolean(data.checked))}
      />
      <div>
        <div style={{ color: '#364445', lineHeight: 1.3 }}>
          Habilitar edição de PL(%) para Usuários da Imobiliária
        </div>
        <div style={{ color: '#9e9e9e', fontSize: 12, marginTop: 2 }}>
          Esta opção estará sempre ativa para Administradores.
        </div>
      </div>
    </div>
  );
};
